import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "types";
import { initialState } from "./initialState";

const selectDomain = (state: RootState) =>
  state.hydraulicManufacturerState || initialState;

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading,
);

export const selectList = createSelector(
  [selectDomain],
  (state) => state.list,
);

export const selectMeta = createSelector(
  [selectDomain],
  (state) => state.meta,
);

export const selectPage = createSelector(
  [selectDomain],
  (state) => state.page,
);

export const selectPerPage = createSelector(
  [selectDomain],
  (state) => state.perPage,
);

export const selectIsAddModalOpen = createSelector(
  [selectDomain],
  (state) => state.isAddModalOpen,
);

export const selectForm = createSelector(
  [selectDomain],
  (state) => state.form,
);

export const selectCanSubmit = createSelector([selectForm], (form) =>
  Boolean(form.code.trim()),
);

export const selectSaving = createSelector(
  [selectDomain],
  (state) => state.saving,
);

export const selectError = createSelector(
  [selectDomain],
  (state) => state.error,
);
